<!-- This component is used to display the direct bill options. The Monthly option is selected by default. -->
<template>
	<div class="flex flex-col gap-4">
		<FormRadioButtons
			class="grid grid-cols-4 gap-4"
			:options="[
				{ label: t('document.monthly'), value: 'Monthly' },
				{ label: t('document.quarterly'), value: 'Quarterly' },
				{ label: t('document.semiAnnual'), value: 'Semi-Annual' },
				{ label: t('document.annual'), value: 'Annual' },
			]"
			v-model="planBillingType"
		/>
	</div>
</template>

<script setup lang="ts">
import FormRadioButtons from '../FormRadioButtons.vue'
import { isDirectBillPayment } from '@/guards'
import { usePresentationLocale } from '@/i18n'
import { usePlanStore } from '@/stores/plan'
import { useSessionDocumentsStore } from '@/stores/sessionDocuments'
import { computed } from 'vue'

const planStore = usePlanStore()
const sessionDocumentsStore = useSessionDocumentsStore()

const plan = computed(() =>
	planStore.getPlan(sessionDocumentsStore.currentPlanHolderID)
)

// The billing type of the active plan
const planBillingType = computed({
	get: () => {
		const payment = plan.value?.payment

		return payment && isDirectBillPayment(payment)
			? payment.paymentDetails.billingType
			: undefined
	},
	set: (value) => {
		if (value && plan.value && isDirectBillPayment(plan.value.payment)) {
			plan.value.payment.paymentDetails.billingType = value
		}
	},
})

const { t } = usePresentationLocale()
</script>
